import React from "react";
import cn from "classnames";
import {CustomTooltip} from "components/CustomTooltip";

export const CustomCounter = ({
  count,
  extraText,
  tooltip,
  small,
  tiny,
  bold,
  addClass,
}) => {
  return (
    <CustomTooltip text={tooltip}>
      <div
        className={cn("df-row-center", {
          "fz-12": !!small,
          "fz-10": !!tiny,
          __bold: !!bold,
          "ml-1": !addClass?.includes("ml-"),
          [addClass]: !!addClass,
        })}
      >{`+${count}${extraText ? ` ${extraText}` : ""}`}</div>
    </CustomTooltip>
  );
};
